import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { pt } from "date-fns/locale";

// Custom toolbar component that adds a date picker
export const CustomToolbar = (toolbar: any) => {
    const handleDateChange = (newDate: Date | null) => {
        if (newDate) {
            toolbar.onNavigate('DATE', newDate);
        }
    };

    return (
        <div className="rbc-toolbar">
            <span className="rbc-btn-group">
                <button type="button" onClick={() => toolbar.onNavigate('TODAY')}>
                    Today
                </button>
                <button type="button" onClick={() => toolbar.onNavigate('PREV')}>
                    Back
                </button>
                <button type="button" onClick={() => toolbar.onNavigate('NEXT')}>
                    Next
                </button>
                <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    adapterLocale={pt}
                >
                    <DatePicker
                        value={toolbar.date}
                        onChange={handleDateChange}
                        format="dd/MM/yyyy"
                        slotProps={{
                            textField: {
                                size: 'small',
                                sx: {
                                    marginTop: '3px',
                                    width: '40px',
                                    '& .MuiOutlinedInput-root': {
                                        height: '29px',
                                        backgroundColor: 'white',
                                        paddingRight: '0px',
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            border: 'none',
                                        },
                                    },
                                    '& .MuiInputBase-input': {
                                        padding: 0,
                                        width: 0,
                                        opacity: 0,
                                    },
                                    '& .MuiInputAdornment-root button': {
                                        border: 'none',
                                    },
                                },
                            },
                        }}
                    />
                </LocalizationProvider>
            </span>
            <span className="rbc-toolbar-label">{toolbar.label}</span>
            <span className="rbc-btn-group">
                {toolbar.views.map((view: string) => (
                    <button
                        key={view}
                        type="button"
                        onClick={() => toolbar.onView(view)}
                        className={toolbar.view === view ? 'rbc-active' : ''}
                    >
                        {view}
                    </button>
                ))}
            </span>
        </div>
    );
};
